export default __webpack_public_path__ + "static/media/main-banner-1.29f91cf2.svg";